import useTranslation from 'next-translate/useTranslation';
import { GameTagCardProps } from './props';
import styles from './styles.module.scss';

export default function GameTagCard({
  gameTag,
  isLoading,
  onClick,
}: GameTagCardProps) {
  const { t } = useTranslation('game-tag');
  function handleClick() {
    if (!onClick) {
      return;
    }

    onClick(gameTag);
  }

  if (isLoading) {
    return;
  }

  return (
    <div onClick={handleClick} className={styles.card}>
      {t(`${gameTag?.id}.name`)}
    </div>
  );
}
